export default __webpack_public_path__ + "static/media/img6.c17800d0.png";